import { render, staticRenderFns } from "./SidebarServiceList.vue?vue&type=template&id=3523cda6&scoped=true&lang=pug&"
import script from "./SidebarServiceList.vue?vue&type=script&lang=ts&"
export * from "./SidebarServiceList.vue?vue&type=script&lang=ts&"
import style0 from "./SidebarServiceList.vue?vue&type=style&index=0&id=3523cda6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3523cda6",
  null
  
)

export default component.exports